import React from 'react';

const LedSettingsRing = (props) => {
  return (
    <svg
      className="booth-img__ring"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0"
      y="0"
      enableBackground="new 1601 -2104 3814 5000"
      version="1.1"
      viewBox="1601 -2104 3814 5000"
      xmlSpace="preserve"
    >
      <path
        fill={props.color}
        d="M3611.5-1526.8h-201.6c-577.4 0-1045.6 468.1-1045.6 1045.5v1694.1c0 577.4 468.1 1045.5 1045.6 1045.5h201.6c577.4 0 1045.5-468.1 1045.5-1045.5V-481.3c0-577.4-468.1-1045.5-1045.5-1045.5zm806 2734.5c0 451.7-366.2 817.8-817.8 817.8h-182.4c-451.7 0-817.8-366.2-817.8-817.8V-469.6c0-451.7 366.2-817.8 817.8-817.8h182.4c451.7 0 817.8 366.2 817.8 817.8v1677.3z"
      ></path>
      <defs>
        <path
          id="a"
          d="M3611.5-1526.8h-201.6c-577.4 0-1045.6 468.1-1045.6 1045.5v1694.1c0 577.4 468.1 1045.5 1045.6 1045.5h201.6c577.4 0 1045.5-468.1 1045.5-1045.5V-481.3c0-577.4-468.1-1045.5-1045.5-1045.5zm806 2734.5c0 451.7-366.2 817.8-817.8 817.8h-182.4c-451.7 0-817.8-366.2-817.8-817.8V-469.6c0-451.7 366.2-817.8 817.8-817.8h182.4c451.7 0 817.8 366.2 817.8 817.8v1677.3z"
        ></path>
      </defs>
      <clipPath>
        <use overflow="visible" xlinkHref="#a"></use>
      </clipPath>
    </svg>
  );
};

export default LedSettingsRing;
